import React from 'react';
import { connect } from 'react-redux';

import { FormattedDate, FormattedDateTime } from 'components/shared/Text/Text';
import {
  hasIntradayBrokerageAccounts,
  getIntradayAsOfDateMap
} from 'state/account/AccountSelectors';
import DisclosureModal from '../Disclosure/DisclosureModal';
import {
  isActiveAdvisory,
  isActivePlus,
  getAccountLevelAsOfDateVisible,
  isBrokerage
} from 'services/Products';
import Content from 'services/Content';
import { intradayRefreshEnabled, intradayOnPageLoadEnabled } from 'services/FeatureFlags';
import { mmmddyyyy } from 'services/Dates';
import { getIntraDayAsOfDate } from 'services/Accounts';
import { getPortfolioAsOfDate } from 'state/portfolio/PortfolioSelectors';

const IntradayAsOfDate = ({
  accountId = '',
  asOfDate,
  balanceBarAsOfDate,
  disclosureContent,
  hasIntradayBrokerageAccounts,
  intradayAsOfDateMap,
  productType,
  isPerformancePage = false
}) => {
  let disclosure = disclosureContent;
  if (isBrokerage(productType)) {
    disclosure = Content.asOfDateDisclosureBrokerage;
  } else if (isActivePlus(productType)) {
    disclosure = Content.asOfDateDisclosureAPP;
  } else if (isActiveAdvisory(productType)) {
    disclosure = Content.asOfDateDisclosureActiveAdvisory;
  }
  const intradayEnabled = intradayRefreshEnabled();
  const hasIntradayData = hasIntradayBrokerageAccounts;
  const intraDayAsOfDate = getIntraDayAsOfDate(intradayAsOfDateMap, accountId);

  // do not show as of date under these conditions
  if (
    !getAccountLevelAsOfDateVisible(productType) ||
    isPerformancePage ||
    (!asOfDate && !intraDayAsOfDate) ||
    (!intraDayAsOfDate && mmmddyyyy(asOfDate) === mmmddyyyy(balanceBarAsOfDate))
  ) {
    return '';
  }

  const canShowIntraday =
    intradayEnabled &&
    !isPerformancePage &&
    hasIntradayData &&
    intraDayAsOfDate;

  return (
    <span
      data-testid={
        canShowIntraday
          ? 'intraday-as-of-date-component'
          : 'as-of-date-component'
      }
      className={`e2e-as-of ${
        canShowIntraday
          ? 'intraday-as-of-date-component'
          : 'as-of-date-component'
      }`}>
      <span>as of </span>
      {canShowIntraday && (
        <span
          data-testid="intraday-as-of-date-time"
          className="intraday-as-of-date-time">
          <FormattedDateTime className="formatted-date">
            {intraDayAsOfDate}
          </FormattedDateTime>
        </span>
      )}
      {!canShowIntraday && (
        <FormattedDate className="formatted-date">{asOfDate}</FormattedDate>
      )}{' '}
      {!intradayOnPageLoadEnabled() && (
        <DisclosureModal
          data-testid={'intraday-as-of-disclosure-modal'}
          linkId={`intraday-as-of-disclosure-modal-${accountId}`}
          className="as-of-date-disclosure"
          content={disclosure}
          title="Important Information Regarding the Updating of Account Balances"
          hideLinkContent
        />
      )}
    </span>
  );
};

const mapStateToProps = (state) => ({
  balanceBarAsOfDate: getPortfolioAsOfDate(state),
  intradayAsOfDateMap: getIntradayAsOfDateMap(state),
  hasIntradayBrokerageAccounts: hasIntradayBrokerageAccounts(state)
});

export default connect(mapStateToProps)(IntradayAsOfDate);
